var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.018 21H3.28V8.972h3.737zM5.129 7.362C3.964 7.362 3 6.357 3 5.15 3 3.5 4.768 2.455 6.214 3.3 6.897 3.66 7.3 4.385 7.3 5.15c0 1.207-.964 2.212-2.17 2.212M20.96 21h-3.696v-5.833c0-1.408-.04-3.178-1.968-3.178-1.929 0-2.21 1.488-2.21 3.057V21H9.348V8.972h3.576v1.649h.04c.523-.925 1.728-1.931 3.536-1.931 3.777 0 4.5 2.494 4.5 5.713V21z"
})));
export default SvgLinkedIn;